/**
 * --------------------------------------------------------------------
 *
 * 	This component is used to embed youtube tutorial videos in the app. 
 * 
 * -------------------------------------------------------------------
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface YoutubeProps {
    link: string
}

const useStyles = makeStyles((theme) => ({
    video: {
        justifyContent: 'center',
        display: 'flex',
        paddingBottom: '50px'
    }
}));

export default function YoutubeComponent(
    props: YoutubeProps
) {
    const classes = useStyles();
    return (
        <div className={classes.video}>
            <iframe
                width="650"
                height="400"
                src={props.link}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded Youtube"
            />
        </div>
    )
}